<!-- Diálogo "Completar cadastro do cliente" da aba "Nova venda".
     Mesmo desenho do irmão app-operar-venda-item-selector: header wave próprio
     (showHeader=false) + corpo rolável + footer com as ações à direita.

     [closable]="true" com [showHeader]="false" NÃO renderiza o "X": o ícone vive
     dentro do header (primeng-dialog: .p-dialog-header-icons está sob
     *ngIf="showHeader"). É o que faz o ESC funcionar — o PrimeNG só honra
     closeOnEscape quando `closable` é true. Fechar por ESC tem exatamente o mesmo
     efeito de Cancelar: o cliente já foi marcado como "oferecido" na ABERTURA. -->
<p-dialog
  [(visible)]="visivel"
  (onHide)="fechar()"
  [modal]="true"
  [showHeader]="false"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '560px', maxWidth: '96vw' }"
  [breakpoints]="{ '640px': '96vw' }"
  styleClass="dialog-wave-redesign completar-cliente-dialog">

  <!-- HEADER WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-id-card" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.venda.completar_cliente.titulo' | translate }}</h2>
        <p>{{ 'contador_operar.venda.completar_cliente.subtitulo' | translate:{ nome: nomeCliente } }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO -->
  <div class="dialog-wave-body" #corpoDialogo>

    <!-- Carregando o cadastro do cliente -->
    <div *ngIf="carregando" class="ccc-estado">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.venda.carregando' | translate }}</span>
    </div>

    <!-- Sem baseline: NÃO dá para gravar (o PUT é replace total) -->
    <div *ngIf="!carregando && erroBaseline" class="ccc-estado ccc-estado--erro" role="alert">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ 'contador_operar.venda.completar_cliente.erro_carregar' | translate }}</span>
    </div>

    <!-- Formulário: os TRÊS grupos aparecem sempre e vêm pré-preenchidos.
         `camposFaltantes` decide só o DESTAQUE.
         Durante o salvamento o bloco inteiro fica inerte — inclusive o
         app-phone-input, que é compartilhado e não expõe [disabled]. -->
    <div *ngIf="!carregando && !erroBaseline" class="ccc-form" [class.ccc-form--bloqueado]="salvando">

      <p class="ccc-ajuda">{{ 'contador_operar.venda.completar_cliente.ajuda' | translate }}</p>

      <!-- ============ Grupo 1: o documento do cliente ============ -->
      <!-- Aparece UM campo, escolhido pelo tipo do cliente, igual à aba Clientes
           (clientes.component.html:52,74): JURÍDICA → RUC, FÍSICA → CI.
           Tipo desconhecido → os DOIS (fallback: na dúvida, não bloquear).

           O diálogo NÃO troca o tipo — só o respeita. E o campo escondido continua
           indo no PUT pelo baseline (montarPayload), nunca é apagado.

           Falta só quando os DOIS estão vazios — isso não mudou, é o que o backend
           faz. -->
      <div class="ccc-grupo" [class.ccc-grupo--faltante]="faltaRucCi()">
        <div class="ccc-grupo-head">
          <span class="ccc-grupo-titulo">{{ chaveTituloRucCi | translate }}</span>
          <span *ngIf="faltaRucCi()" class="ccc-badge">
            {{ 'contador_operar.venda.completar_cliente.badge_faltando' | translate }}
          </span>
        </div>
        <small class="ccc-grupo-ajuda">{{ chaveAjudaRucCi | translate }}</small>

        <!-- Com um campo só, ele ocupa a linha inteira (como Telefone e Cidade). -->
        <div class="ccc-dupla" [class.ccc-dupla--unico]="!mostrarRuc || !mostrarCi">
          <div class="field" *ngIf="mostrarRuc">
            <!-- Com um campo só, o título do grupo JÁ é o rótulo ("RUC"): repeti-lo
                 aqui seria ruído. O nome acessível fica no aria-label, que continua
                 valendo nos dois cenários. -->
            <label for="ccc-ruc" *ngIf="mostrarCi">{{ 'contador_operar.venda.completar_cliente.label_ruc' | translate }}</label>
            <!-- SEM [digitsOnly]: o RUC aceita "-" antes do dígito verificador.
                 A sanitização é a mesma da edição em /clientes: só [0-9-]. -->
            <input
              id="ccc-ruc"
              type="text"
              pInputText
              inputmode="numeric"
              class="w-full"
              [(ngModel)]="form.ruc"
              (input)="onRucInput($event)"
              [attr.aria-label]="'contador_operar.venda.completar_cliente.label_ruc' | translate"
              [attr.aria-invalid]="(tentouSalvar && (!grupoRucCiOk || !rucFormatoOk)) || !!erroRuc" />
          </div>
          <div class="field" *ngIf="mostrarCi">
            <label for="ccc-ci" *ngIf="mostrarRuc">{{ 'contador_operar.venda.completar_cliente.label_ci' | translate }}</label>
            <input
              id="ccc-ci"
              type="text"
              pInputText
              digitsOnly
              inputmode="numeric"
              maxlength="8"
              class="w-full"
              [(ngModel)]="form.ci"
              (ngModelChange)="onCiModelChange($event)"
              [attr.aria-label]="'contador_operar.venda.completar_cliente.label_ci' | translate"
              [attr.aria-invalid]="(tentouSalvar && (!grupoRucCiOk || !ciFormatoOk)) || !!erroCi" />
          </div>
        </div>

        <small *ngIf="tentouSalvar && !grupoRucCiOk" class="ccc-erro" aria-live="polite">
          {{ chaveObrigatorioRucCi | translate }}
        </small>
        <!-- Formato: só depois que há algo digitado (senão duplicaria a mensagem acima). -->
        <small *ngIf="tentouSalvar && grupoRucCiOk && !rucFormatoOk" class="ccc-erro" aria-live="polite">
          {{ 'contador_operar.venda.completar_cliente.ruc_formato_invalido' | translate }}
        </small>
        <small *ngIf="tentouSalvar && grupoRucCiOk && !ciFormatoOk" class="ccc-erro" aria-live="polite">
          {{ 'contador_operar.venda.completar_cliente.ci_formato_invalido' | translate }}
        </small>
        <small *ngIf="erroRuc" class="ccc-erro" aria-live="polite">{{ erroRuc }}</small>
        <small *ngIf="erroCi" class="ccc-erro" aria-live="polite">{{ erroCi }}</small>
      </div>

      <!-- ============ Grupo 2: Telefone ============ -->
      <div class="ccc-grupo" [class.ccc-grupo--faltante]="faltaTelefone()">
        <div class="ccc-grupo-head">
          <span class="ccc-grupo-titulo">{{ 'contador_operar.venda.completar_cliente.grupo_telefone' | translate }}</span>
          <span *ngIf="faltaTelefone()" class="ccc-badge">
            {{ 'contador_operar.venda.completar_cliente.badge_faltando' | translate }}
          </span>
        </div>

        <!-- Componente compartilhado, consumido sem alteração. Ele emite DÍGITOS
             puros para `form.telefone`; a máscara é só exibição. -->
        <div class="field ccc-campo-telefone">
          <app-phone-input
            [(telefone)]="form.telefone"
            [(ddi)]="form.ddi"
            [label]="''">
          </app-phone-input>
        </div>

        <small *ngIf="tentouSalvar && !grupoTelefoneOk" class="ccc-erro" aria-live="polite">
          {{ (form.telefone
                ? 'contador_operar.venda.completar_cliente.telefone_invalido'
                : 'contador_operar.venda.completar_cliente.obrigatorio_telefone') | translate }}
        </small>
        <small *ngIf="erroTelefone" class="ccc-erro" aria-live="polite">{{ erroTelefone }}</small>
      </div>

      <!-- ============ Grupo 3: Cidade ============ -->
      <div class="ccc-grupo" [class.ccc-grupo--faltante]="faltaCidade()">
        <div class="ccc-grupo-head">
          <span class="ccc-grupo-titulo">{{ 'contador_operar.venda.completar_cliente.grupo_cidade' | translate }}</span>
          <span *ngIf="faltaCidade()" class="ccc-badge">
            {{ 'contador_operar.venda.completar_cliente.badge_faltando' | translate }}
          </span>
        </div>

        <div class="field">
          <!-- appendTo="body" é obrigatório: sem ele o painel é recortado pelo
               overflow-y do .p-dialog-content.
               optionValue="id" mantém o modelo ESCALAR — assim a ordem de chegada
               do baseline e da lista de cidades deixa de importar. -->
          <p-dropdown
            inputId="ccc-cidade"
            [options]="cidadeOptions"
            [(ngModel)]="form.cidadeId"
            optionLabel="displayLabel"
            optionValue="id"
            [filter]="true"
            filterBy="displayLabel"
            [showClear]="true"
            [loading]="cidadeCarregando"
            [placeholder]="'contador_operar.venda.completar_cliente.placeholder_cidade' | translate"
            [style]="{ width: '100%' }"
            appendTo="body"
            panelStyleClass="dropdown-panel-above-modal">
          </p-dropdown>
        </div>

        <!-- Lista de cidades indisponível NÃO desabilita "Salvar": se o cadastro já
             tinha cidade, o valor continua no modelo e a venda não é bloqueada. -->
        <small *ngIf="erroCidades" class="ccc-erro" aria-live="polite">
          {{ 'contador_operar.venda.completar_cliente.erro_carregar_cidades' | translate }}
        </small>
        <small *ngIf="tentouSalvar && !grupoCidadeOk" class="ccc-erro" aria-live="polite">
          {{ 'contador_operar.venda.completar_cliente.obrigatorio_cidade' | translate }}
        </small>
        <small *ngIf="erroCidade" class="ccc-erro" aria-live="polite">{{ erroCidade }}</small>
      </div>

      <!-- 403, ou 400 num campo que este diálogo não edita -->
      <div *ngIf="erroGeral" class="ccc-erro-geral" role="alert" aria-live="polite">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>{{ erroGeral }}</span>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton
      type="button"
      class="p-button-secondary"
      [label]="'contador_operar.venda.completar_cliente.cancelar' | translate"
      [disabled]="salvando"
      (click)="fechar()">
    </button>
    <!-- Desabilitado APENAS sem baseline (não há o que gravar) ou durante o
         salvamento. Com o formulário incompleto o botão é CLICÁVEL: o clique acende
         as mensagens inline e nenhum PUT é enviado. -->
    <button pButton
      type="button"
      class="btn-primary"
      [icon]="salvando ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
      [label]="'contador_operar.venda.completar_cliente.salvar' | translate"
      [disabled]="!podeGravar"
      (click)="salvar()">
    </button>
  </ng-template>
</p-dialog>
